module.exports = __webpack_public_path__ + "img/f48.c40bacbc.png";